































































import { Component, Prop, Vue } from 'vue-property-decorator'
import InputField from '@/components/InputField.vue'
//import * as mathjs from 'mathjs'

@Component({
  components: {
    InputField
  },
  name: 'frac-field',
  props: { frac: Array },
  data() {
    return {
      data: null,
    }
  },
  methods: {
    onChange(value) {
      //console.log("FRAC CHN", value)
      /*console.log("FRAC CHN-2", this.$refs.input)
      this.$refs.input.forEach(item => {
        console.log("FRAC CHN-3", item.value)
      });*/
    },
    getValue() {
      let result = []
      this.$refs.input.forEach(item => {
        //console.log("FRAC CHN-3", item.value)
        result.push(item.getValue())
      });
      return result
      /*var elements = this.$refs.frac.querySelectorAll('span');
      var result = []
      elements.forEach(element => {
        if(element.querySelector('input')) {
          result.push(element.querySelector('input').value)
        } else {
          result.push(element.textContent)
        }
      });
      if(result.length < 3) result.splice(0, 0, 0)

      if(!result[0]) {
        return !result[1] ? 0 : (result[1]+"/"+result[2])
      } else {
        return !result[1] ? 0 : (parseInt(result[0]) * parseInt(result[2]) + parseInt(result[1]))+"/"+result[2]
      } */
    },
    getComponent() {
      let result = []
      this.$refs.input.forEach(item => {
        //console.log("FRAC CHN-3", item.value)
        result.push(item)
      });
      return result
    },
    getType() {
      return this.data.length ? 'static' : 'input'
    }
  },
  mounted() {
    
  },
  computed: {
    //
  },
  watch: {
    frac: {
      immediate: true,
      handler(value) {
        let result = []
        for(var i=0; i< value.length; i++) {
          if(value[i]) {
            result[i] = []
            for(var j=0; j< value[i].length; j++) {
              //console.log("CHAR", i, j, value[i].charAt(j))
              result[i].push(value[i].charAt(j))
            }
          } else {
            result.push("")
          }
        }
        this.data = value
      }
    }
  }
})
export default class FracField extends Vue {}

